import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DataTable, { DtColumn } from '../components/DataTable';
import { GUNCEL_AY, cozGuncelAy } from '../utils/guncelAy';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const YIL = new Date().getFullYear();

const VARLIK_ALANLARI = ['aygir', 'kisrak', 'tay3_erkek', 'tay3_disi', 'tay2_erkek', 'tay2_disi',
                         'tay1_erkek', 'tay1_disi', 'sut_tay_erkek', 'sut_tay_disi',
                         'reforme_erkek', 'reforme_disi'];
const SATIS_ALANLARI = VARLIK_ALANLARI.map(a => `satis_${a}`);

const emptyForm: any = {
  isletme_id: '', yil: YIL, ay: new Date().getMonth() + 1,
  aygir: 0, kisrak: 0, tay3_erkek: 0, tay3_disi: 0,
  tay2_erkek: 0, tay2_disi: 0, tay1_erkek: 0, tay1_disi: 0,
  sut_tay_erkek: 0, sut_tay_disi: 0, reforme_erkek: 0, reforme_disi: 0,
  satis_aygir: 0, satis_kisrak: 0, satis_tay3_erkek: 0, satis_tay3_disi: 0,
  satis_tay2_erkek: 0, satis_tay2_disi: 0, satis_tay1_erkek: 0, satis_tay1_disi: 0,
  satis_sut_tay_erkek: 0, satis_sut_tay_disi: 0,
  sperma_uretim_doz: 0, sperma_satis_doz: 0,
  pansiyoner_at: 0, satis_geliri_tl: 0, yaris_primi_tl: 0,
  dogum_sayisi: 0, aciklama: ''
};

export default function AtYetistiricilik() {
  const [kayitlar, setKayitlar] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [ozet, setOzet] = useState<any>(null);
  const [secili, setSecili] = useState<any>(null);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState<any>({ ...emptyForm });
  const [filtre, setFiltre] = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return {
      isletme_id: sp.get('isletme') || '',
      yil: Number(sp.get('yil') || YIL),
      ay: sp.get('ay') || GUNCEL_AY
    };
  })());
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isGM = user?.rol && ['super_admin', 'gm_yonetici', 'gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin', 'gm_yonetici'].includes(user.rol);

  useEffect(() => {
    axios.get(`${API}/api/at/isletmeler`, { headers: headers() }).then(r => {
      setIsletmeler(r.data);
      if (!isGM && user?.isletme_id) {
        setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
        setForm((f: any) => ({ ...f, isletme_id: user.isletme_id }));
      }
    }).catch(() => setIsletmeler([]));
  }, []);

  useEffect(() => { yukle(); }, [filtre]);

  const [cozulenAy, setCozulenAy] = useState<number | null>(null);

  const yukle = async () => {
    let ay: any = filtre.ay;
    if (ay === GUNCEL_AY) {
      ay = await cozGuncelAy(filtre.yil, filtre.isletme_id, (params: any) =>
        axios.get(`${API}/api/at/`, { headers: headers(), params }));
      setCozulenAy(ay);
    } else {
      setCozulenAy(null);
    }
    const p: any = { yil: filtre.yil };
    if (filtre.isletme_id) p.isletme_id = filtre.isletme_id;
    if (ay) p.ay = ay;
    axios.get(`${API}/api/at/`, { headers: headers(), params: p }).then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
    axios.get(`${API}/api/at/ozet`, { headers: headers(), params: { yil: filtre.yil, ...(filtre.isletme_id ? { isletme_id: filtre.isletme_id } : {}) } })
      .then(r => setOzet(r.data)).catch(() => setOzet(null));
  };

  const toplamVarlik = (f: any) => VARLIK_ALANLARI.reduce((s, k) => s + (Number(f[k]) || 0), 0);
  const toplamSatis = (f: any) => SATIS_ALANLARI.reduce((s, k) => s + (Number(f[k]) || 0), 0);

  const duzenleAc = (k: any) => { setSecili(k); setForm({ ...k }); setHata(''); setModalAcik(true); };
  const yeniAc = () => { setForm({ ...emptyForm, isletme_id: isGM ? '' : user?.isletme_id }); setSecili(null); setHata(''); setModalAcik(true); };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      const body = { ...form, isletme_id: Number(form.isletme_id) };
      if (secili) {
        await axios.put(`${API}/api/at/${secili.id}`, body, { headers: headers() });
      } else {
        await axios.post(`${API}/api/at/`, body, { headers: headers() });
      }
      yukle(); setModalAcik(false); setSecili(null); setForm({ ...emptyForm });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Silmek istiyor musunuz?')) return;
    try {
      await axios.delete(`${API}/api/at/${id}`, { headers: headers() });
      yukle();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Silme işlemi başarısız oldu');
    }
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) { try { await axios.delete(`${API}/api/at/${k.id}`, { headers: headers() }); } catch {} }
    yukle();
  };

  const n = (v: any) => Number(v || 0).toLocaleString('tr-TR');
  const f2 = (v: any) => Number(v || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 });
  const inp = (field: string) => ({
    className: "form-control", type: "number" as const, value: form[field],
    onChange: (e: any) => setForm({ ...form, [field]: Number(e.target.value) })
  });

  const atColumns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'aygir', label: 'Aygır', sortable: true, render: (k: any) => n(k.aygir), sortValue: (k: any) => Number(k.aygir || 0) },
    { key: 'kisrak', label: 'Kısrak', sortable: true, render: (k: any) => n(k.kisrak), sortValue: (k: any) => Number(k.kisrak || 0) },
    { key: 'tay3e', label: '3 Tay E', sortable: true, render: (k: any) => n(k.tay3_erkek), sortValue: (k: any) => Number(k.tay3_erkek || 0) },
    { key: 'tay3d', label: '3 Tay D', sortable: true, render: (k: any) => n(k.tay3_disi), sortValue: (k: any) => Number(k.tay3_disi || 0) },
    { key: 'tay2e', label: '2 Tay E', sortable: true, render: (k: any) => n(k.tay2_erkek), sortValue: (k: any) => Number(k.tay2_erkek || 0) },
    { key: 'tay2d', label: '2 Tay D', sortable: true, render: (k: any) => n(k.tay2_disi), sortValue: (k: any) => Number(k.tay2_disi || 0) },
    { key: 'tay1e', label: '1 Tay E', sortable: true, render: (k: any) => n(k.tay1_erkek), sortValue: (k: any) => Number(k.tay1_erkek || 0) },
    { key: 'tay1d', label: '1 Tay D', sortable: true, render: (k: any) => n(k.tay1_disi), sortValue: (k: any) => Number(k.tay1_disi || 0) },
    { key: 'sut_tay_e', label: 'Süt Tay E', sortable: true, render: (k: any) => n(k.sut_tay_erkek), sortValue: (k: any) => Number(k.sut_tay_erkek || 0) },
    { key: 'sut_tay_d', label: 'Süt Tay D', sortable: true, render: (k: any) => n(k.sut_tay_disi), sortValue: (k: any) => Number(k.sut_tay_disi || 0) },
    { key: 'reforme_e', label: 'Ref. E', sortable: true, render: (k: any) => n(k.reforme_erkek), sortValue: (k: any) => Number(k.reforme_erkek || 0) },
    { key: 'reforme_d', label: 'Ref. D', sortable: true, render: (k: any) => n(k.reforme_disi), sortValue: (k: any) => Number(k.reforme_disi || 0) },
    { key: 'toplam', label: 'Toplam', sortable: true, render: (k: any) => <strong>{n(k.toplam_at)}</strong>, sortValue: (k: any) => Number(k.toplam_at || 0) },
    { key: 'satis', label: 'Satış', sortable: true, render: (k: any) => <strong>{n(k.satis_toplam)}</strong>, sortValue: (k: any) => Number(k.satis_toplam || 0) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(k)}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  return (
    <div>
      <div className="page-header">
        <h1>🐎 Safkan Arap At Yetistiriciligi</h1>
        <p>Karacabey, Anadolu ve Sultansuyu Isletmelerinde yurutulen at yetistiriciligi verileri</p>
      </div>

      {ozet && (
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-icon">🐎</div><div><div className="stat-value">{n(ozet.toplam_at)}</div><div className="stat-label">Toplam At</div></div></div>
          <div className="stat-card"><div className="stat-icon">💰</div><div><div className="stat-value">{n(ozet.toplam_satis)}</div><div className="stat-label">Toplam Satis (Bas)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🐴</div><div><div className="stat-value">{n(ozet.toplam_dogum)}</div><div className="stat-label">Dogum</div></div></div>
          <div className="stat-card"><div className="stat-icon">🧬</div><div><div className="stat-value">{n(ozet.toplam_sperma_uretim)}</div><div className="stat-label">Sperma (Doz)</div></div></div>
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} />
            <select className="search-input" style={{ width: 120 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value={GUNCEL_AY}>Güncel Ay{cozulenAy ? ` (${AYLAR[cozulenAy]})` : ''}</option>
              <option value="">Tum Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
            </select>
            {isGM && (
              <select className="search-input" style={{ width: 220 }} value={filtre.isletme_id}
                onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                <option value="">Tum Isletmeler</option>
                {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
              </select>
            )}
          </div>
          <button className="btn btn-success" onClick={yeniAc}>+ Yeni Kayit</button>
        </div>

        <DataTable columns={atColumns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="at-yetistiricilik" />
      </div>

      {/* Modal */}
      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 680 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🐎 At Yetistiriciligi Kayit Girisi</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              <div className="form-row">
                {isGM && (
                  <div className="form-group">
                    <label>Isletme *</label>
                    <select className="form-control" value={form.isletme_id}
                      onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                      <option value="">Seciniz</option>
                      {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group">
                  <label>Yil *</label>
                  <input className="form-control" type="number" value={form.yil}
                    onChange={e => setForm({ ...form, yil: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Ay *</label>
                  <select className="form-control" value={form.ay}
                    onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
                  </select>
                </div>
              </div>

              <div style={{ fontSize: 13, fontWeight: 600, color: '#1a5276', marginBottom: 8, marginTop: 4 }}>🐎 Hayvan Varligi</div>
              <div className="form-row">
                <div className="form-group"><label>Aygir</label><input {...inp('aygir')} /></div>
                <div className="form-group"><label>Kisrak</label><input {...inp('kisrak')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>3 Tay Erkek</label><input {...inp('tay3_erkek')} /></div>
                <div className="form-group"><label>3 Tay Disi</label><input {...inp('tay3_disi')} /></div>
                <div className="form-group"><label>2 Tay Erkek</label><input {...inp('tay2_erkek')} /></div>
                <div className="form-group"><label>2 Tay Disi</label><input {...inp('tay2_disi')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>1 Tay Erkek</label><input {...inp('tay1_erkek')} /></div>
                <div className="form-group"><label>1 Tay Disi</label><input {...inp('tay1_disi')} /></div>
                <div className="form-group"><label>Sut Tay Erkek</label><input {...inp('sut_tay_erkek')} /></div>
                <div className="form-group"><label>Sut Tay Disi</label><input {...inp('sut_tay_disi')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Reforme Erkek</label><input {...inp('reforme_erkek')} /></div>
                <div className="form-group"><label>Reforme Disi</label><input {...inp('reforme_disi')} /></div>
              </div>
              <div style={{ background: '#f0f7ff', borderRadius: 8, padding: '8px 14px', marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 13, color: '#555' }}>Toplam At (Bas)</span>
                <span style={{ fontSize: 18, fontWeight: 700, color: '#1a5276' }}>{n(toplamVarlik(form))}</span>
              </div>

              <div style={{ fontSize: 13, fontWeight: 600, color: '#1a5276', marginBottom: 8 }}>💰 Satislar</div>
              <div className="form-row">
                <div className="form-group"><label>Aygir Satis</label><input {...inp('satis_aygir')} /></div>
                <div className="form-group"><label>Kisrak Satis</label><input {...inp('satis_kisrak')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>3 Tay E Satis</label><input {...inp('satis_tay3_erkek')} /></div>
                <div className="form-group"><label>3 Tay D Satis</label><input {...inp('satis_tay3_disi')} /></div>
                <div className="form-group"><label>2 Tay E Satis</label><input {...inp('satis_tay2_erkek')} /></div>
                <div className="form-group"><label>2 Tay D Satis</label><input {...inp('satis_tay2_disi')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>1 Tay E Satis</label><input {...inp('satis_tay1_erkek')} /></div>
                <div className="form-group"><label>1 Tay D Satis</label><input {...inp('satis_tay1_disi')} /></div>
                <div className="form-group"><label>Sut Tay E Satis</label><input {...inp('satis_sut_tay_erkek')} /></div>
                <div className="form-group"><label>Sut Tay D Satis</label><input {...inp('satis_sut_tay_disi')} /></div>
              </div>
              <div style={{ background: '#fff5f0', borderRadius: 8, padding: '8px 14px', marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 13, color: '#555' }}>Toplam Satis (Bas)</span>
                <span style={{ fontSize: 18, fontWeight: 700, color: '#c0392b' }}>{n(toplamSatis(form))}</span>
              </div>

              <div style={{ fontSize: 13, fontWeight: 600, color: '#1a5276', marginBottom: 8 }}>🧬 Diger Bilgiler</div>
              <div className="form-row">
                <div className="form-group"><label>Dogum Sayisi</label><input {...inp('dogum_sayisi')} /></div>
                <div className="form-group"><label>Sperma Uretim (Doz)</label><input {...inp('sperma_uretim_doz')} /></div>
                <div className="form-group"><label>Sperma Satis (Doz)</label><input {...inp('sperma_satis_doz')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Pansiyoner At</label><input {...inp('pansiyoner_at')} /></div>
                <div className="form-group"><label>Satis Geliri (TL)</label><input {...inp('satis_geliri_tl')} /></div>
                <div className="form-group"><label>Yaris Primi (TL)</label><input {...inp('yaris_primi_tl')} /></div>
              </div>

              <div className="form-group">
                <label>Aciklama</label>
                <textarea className="form-control" value={form.aciklama}
                  onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>Iptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>
                {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
